module.exports = __webpack_public_path__ + "img/milan.b10389fb.png";